(function(){
  if(window.__lmExtras)return;window.__lmExtras=true;
  function esc(s){return String(s==null?'':s).replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]})}
  function money(c){var n=(Number(c)||0)/100;try{return new Intl.NumberFormat(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'NZD'}).format(n)}catch(e){return '$'+n.toFixed(2)}}
  function root(){return document.querySelector('[id^="LittosMasterProduct-"]')}
  function vis(el){return !!(el&&el.offsetParent!==null&&el.getClientRects().length)}

  /* ---------- Gift popup ---------- */
  var modal=null,cache={};
  function giftData(){
    var n=document.querySelector('[data-lm-reward-milestones]');if(!n)return null;
    try{return JSON.parse(n.textContent)}catch(e){return null}
  }
  function ensureModal(){
    if(modal)return modal;
    modal=document.createElement('div');modal.className='lm-gift-modal';modal.hidden=true;
    modal.innerHTML='<div class="lm-gift-modal__bg" data-close></div><div class="lm-gift-modal__box" role="dialog" aria-modal="true" aria-labelledby="lmGiftTitle"><button type="button" class="lm-gift-modal__x" data-close aria-label="Close">×</button><div class="lm-gift-modal__img"></div><div class="lm-gift-modal__body"><span class="lm-gift-modal__eyebrow"></span><h3 id="lmGiftTitle" class="lm-gift-modal__title"></h3><div class="lm-gift-modal__price"></div><div class="lm-gift-modal__desc"></div></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click',function(e){
      if(e.target.closest('[data-close]')){close();return}
      var nb=e.target.closest('[data-gift-nav],[data-gift-dot]');if(!nb)return;
      var tr=modal.querySelector('.lm-gift-modal__track');if(!tr)return;
      var w=tr.clientWidth,cur=Math.round(tr.scrollLeft/Math.max(1,w));
      var to=nb.hasAttribute('data-gift-dot')?Number(nb.getAttribute('data-gift-dot')):cur+Number(nb.getAttribute('data-gift-nav'));
      tr.scrollTo({left:Math.max(0,to)*w,behavior:'smooth'});
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)close()});
    return modal;
  }
  var lastFocus=null;
  function close(){if(!modal)return;modal.hidden=true;document.documentElement.classList.remove('lm-gift-open');if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  function fill(info,threshold){
    var m=ensureModal();
    var box=m.querySelector('.lm-gift-modal__img'),gal=(info.images||[]).filter(Boolean);
    if(gal.length>1){
      box.classList.add('is-gallery');
      box.innerHTML='<div class="lm-gift-modal__track" tabindex="0" aria-label="'+esc(info.title)+' images">'+gal.map(function(u,i){return '<div class="lm-gift-modal__slide"><img src="'+esc(u)+'" alt="'+esc(info.title)+' '+(i+1)+'/'+gal.length+'"'+(i?' loading="lazy"':'')+'></div>'}).join('')+'</div>'+
        '<button type="button" class="lm-gift-modal__nav lm-gift-modal__nav--prev" data-gift-nav="-1" aria-label="Previous image">&#8249;</button><button type="button" class="lm-gift-modal__nav lm-gift-modal__nav--next" data-gift-nav="1" aria-label="Next image">&#8250;</button>'+
        '<div class="lm-gift-modal__dots">'+gal.map(function(u,i){return '<button type="button" class="lm-gift-modal__dot'+(i?'':' is-on')+'" data-gift-dot="'+i+'" aria-label="Image '+(i+1)+'"></button>'}).join('')+'</div>';
      var tr=box.querySelector('.lm-gift-modal__track');
      tr.addEventListener('scroll',function(){var i=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));box.querySelectorAll('.lm-gift-modal__dot').forEach(function(d,j){d.classList.toggle('is-on',j===i)});box.classList.toggle('at-start',i<=0);box.classList.toggle('at-end',i>=gal.length-1)},{passive:true});
      box.classList.add('at-start');
    }else{
      box.classList.remove('is-gallery','at-start','at-end');
      box.innerHTML=info.image?'<img src="'+esc(info.image)+'" alt="'+esc(info.title)+'">':'';
    }
    m.querySelector('.lm-gift-modal__eyebrow').textContent='FREE WITH '+threshold+' PACKS';
    m.querySelector('.lm-gift-modal__title').textContent=info.title;
    m.querySelector('.lm-gift-modal__price').innerHTML=info.price?'<s>'+esc(info.price)+'</s> <b>FREE</b>':'<b>FREE</b>';
    m.querySelector('.lm-gift-modal__desc').innerHTML=info.desc||'';
  }
  function trimDesc(html){
    var d=document.createElement('div');d.innerHTML=String(html||'').replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi,' $&');
    var t=(d.textContent||'').replace(/\s+/g,' ').trim();
    if(t.length>260){t=t.slice(0,260);t=t.slice(0,t.lastIndexOf(' '))+'…'}
    return t?'<p>'+esc(t)+'</p>':'';
  }
  function openGift(threshold,trigger){
    var d=giftData();if(!d)return;
    var m=(d.milestones||[]).find(function(x){return Number(x.threshold)===Number(threshold)});
    if(!m||!m.gift||!m.gift.enabled)return;
    var g=m.gift;lastFocus=trigger;
    var base={title:g.productTitle||g.label,image:g.imageUrl||'',price:Number(g.originalPriceCents)>0?money(g.originalPriceCents):'',desc:''};
    var isFreeTin=/free\s*tin/i.test(g.label||'')||/free\s*tin/i.test(g.productTitle||'');
    if(isFreeTin&&!g.productHandle){
      base.title='Free Tin';base.image=d.freeTinPreviewImage||base.image;
      base.desc='<p>A bonus tin of Littos Coffee Chews, picked by us. It’s often a flavour you haven’t tried yet, so every order comes with a little surprise.</p>';
    }
    fill(base,threshold);
    var mm=ensureModal();mm.hidden=false;document.documentElement.classList.add('lm-gift-open');
    var x=mm.querySelector('.lm-gift-modal__x');if(x)x.focus();
    if(g.productHandle){
      var h=g.productHandle;
      var p=cache[h]||(cache[h]=fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'products/'+encodeURIComponent(h)+'.js').then(function(r){if(!r.ok)throw 0;return r.json()}));
      p.then(function(pr){
        var imgs=pr.images||[];var img=imgs[1]||imgs[0]||base.image;
        var abs=function(u){return u&&u.indexOf('//')===0?'https:'+u:u};img=abs(img);
        /* 12 Oct: non Free Tin gifts get a swipeable gallery from the product's own media */
        var gallery=[];
        if(!isFreeTin){
          gallery=[img].concat(imgs.map(abs).filter(function(u){return u&&u!==img}));
          gallery=gallery.map(function(u){return u+(u.indexOf('?')>-1?'&':'?')+'width=900'});
        }
        fill({title:pr.title||base.title,image:img,images:gallery,price:pr.price?money(pr.price):base.price,desc:trimDesc(pr.description)},threshold);
      }).catch(function(){});
    }
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-lm-gift-open]');
    if(!t)return;e.preventDefault();openGift(t.getAttribute('data-lm-gift-open'),t);
  });
  document.addEventListener('keydown',function(e){
    if((e.key==='Enter'||e.key===' ')&&e.target&&e.target.matches&&e.target.matches('[data-lm-gift-open]')){e.preventDefault();openGift(e.target.getAttribute('data-lm-gift-open'),e.target)}
  });
  function markGifts(){
    var d=giftData();if(!d)return;
    document.querySelectorAll('.lm-rl .lm-rl-node').forEach(function(node){
      if(node.dataset.lmGiftBound)return;
      var t=node.getAttribute('data-lm-rl-node');
      var m=(d.milestones||[]).find(function(x){return String(x.threshold)===String(t)});
      node.dataset.lmGiftBound='1';
      if(!m||!m.gift||!m.gift.enabled)return;
      var v=node.querySelector('.lm-rl-visual');
      if(v){v.setAttribute('data-lm-gift-open',t);v.setAttribute('role','button');v.setAttribute('tabindex','0');v.setAttribute('aria-label','See gift: '+(m.gift.productTitle||m.gift.label));v.classList.add('is-gift');v.insertAdjacentHTML('beforeend','<span class="lm-rl-info" aria-hidden="true">i</span>')}
      var w=node.querySelector('.lm-rl-worth');if(w)w.remove();
    });
  }


  /* ---------- Gift eligibility, mirrors the cart drawer rules ----------
     Discounts and gifts use the same price-weighted pack count (Pricing
     Engine): 24-tin = 1 pack, 10-tin ~ 0.43 pack, so the "N x 10 TINS"
     shown on each node is what unlocks that node's gift too.
     Free Tin is open to one-time and subscription, other gifts need
     Subscribe. Bundles unchanged.
     The "Gift with Subscribe" note is always shown for subscription-only gifts
     (not toggled with the purchase mode), so the ladder never changes height
     when the shopper switches between Subscribe and One-Time. */
  function giftUniversal(g){
    return String(g.access||'').toLowerCase()==='all'||String(g.purchaseMode||'').toLowerCase()==='all'||/free\s*tin/i.test(String(g.label||''));
  }
  function nodeNeed(node,t){
    var n=node.querySelector('[data-lm-rl-n]');
    var v=n?parseInt(n.textContent,10):NaN;
    return v>0?v:t;
  }
  function annotateGifts(){
    var r=root();if(!r)return;var d=giftData();if(!d)return;
    var el=r.querySelector('[data-lm-rl="single"]');if(!el)return;
    var mode=r.querySelector('.lm-ritual [data-littos-purchase-mode]');var sub=!!(mode&&/sub/i.test(mode.value||''));
    var q=r.querySelector('.lm-ritual [data-lm-quantity-input]');var qty=q?parseInt(q.value,10)||1:1;
    var ms=(d.milestones||[]);
    var nextNode=null;
    el.querySelectorAll('[data-lm-rl-node]').forEach(function(node){
      var t=Number(node.getAttribute('data-lm-rl-node'));
      var need=nodeNeed(node,t);
      if(!nextNode&&qty<need)nextNode={t:t,need:need};
      var m=ms.find(function(x){return Number(x.threshold)===t});
      var g=m&&m.gift&&m.gift.enabled?m.gift:null;
      var note=node.querySelector('.lm-rl-giftnote');
      if(!g){if(note)note.remove();node.classList.remove('gift-locked');return}
      var uni=giftUniversal(g);
      /* 12 Oct: Subscribe -> show the gift name only; One-time -> swap the name for "Gift with Subscribe" (one line either way) */
      var gname=node.querySelector('.lm-rl-gift');if(gname)gname.style.display=(!uni&&!sub)?'none':'';
      var msg=(!uni&&!sub)?'Gift with Subscribe':'';
      var gotGift=qty>=need&&(uni||sub);
      node.classList.toggle('gift-locked',!gotGift);
      if(msg){
        if(!note){note=document.createElement('span');note.className='lm-rl-giftnote';var gl=node.querySelector('.lm-rl-gift');if(gl)gl.insertAdjacentElement('afterend',note);}
        if(note.textContent!==msg)note.textContent=msg;
      }else if(note)note.remove();
    });
    var hint=el.querySelector('[data-lm-rl-next]');
    if(hint&&!sub&&nextNode){
      var txt0=hint.textContent;
      var nm=ms.find(function(x){return Number(x.threshold)===nextNode.t});
      if(nm&&nm.gift&&nm.gift.enabled&&!giftUniversal(nm.gift)&&/ \+ [A-Z ]+$/.test(txt0)&&!/Subscribe/.test(txt0))hint.textContent=txt0+' (Subscribe)';
    }
  }

  /* ---------- Sticky add to cart ---------- */
  var bar=null;
  function mainAtc(){
    var r=root();if(!r)return null;
    var bundleOpen=r.querySelector('.lm-inline-bundle-panel:not([hidden])');
    if(bundleOpen){var b=r.querySelector('[data-lm-bundle-atc]');if(b)return b}
    var c=[].slice.call(r.querySelectorAll('.lm-ritual button[type="submit"], .lm-ritual [data-lm-atc]')).filter(vis);
    return c[0]||null;
  }
  function buildBar(){
    bar=document.createElement('div');bar.className='lm-sticky';bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<div class="lm-sticky__in"><span class="lm-sticky__img"></span><span class="lm-sticky__txt"><b class="lm-sticky__title"></b><span class="lm-sticky__sub"></span><button type="button" class="lm-sticky__deal" hidden></button><span class="lm-sticky__mp"></span></span><span class="lm-sticky__price"></span><span class="lm-sticky__qty"><button type="button" data-lm-sq="-1" aria-label="Decrease quantity">−</button><span></span><button type="button" data-lm-sq="1" aria-label="Increase quantity">+</button></span><button type="button" class="lm-sticky__btn" tabindex="-1"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 8V6a3 3 0 0 1 6 0v2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span>ADD TO CART</span></button></div>';
    document.body.appendChild(bar);
    bar.querySelector('.lm-sticky__qty').addEventListener('click',function(e){
      var b=e.target.closest('[data-lm-sq]');if(!b)return;var r=root();if(!r)return;
      var m=r.querySelectorAll('.lm-ritual .lm-qty-btn');if(!m.length)return;
      (b.getAttribute('data-lm-sq')==='-1'?m[0]:m[m.length-1]).click();setTimeout(syncBar,60);
    });
    /* 12 Oct mobile: tap the deal pill = add the missing qty to unlock the next discount */
    bar.querySelector('.lm-sticky__deal').addEventListener('click',function(){
      var n=Number(this.dataset.n)||0;if(!n)return;var r=root();if(!r)return;
      var m=r.querySelectorAll('.lm-ritual .lm-qty-btn');if(!m.length)return;var plus=m[m.length-1];
      for(var i=0;i<n;i++)setTimeout(function(){plus.click()},i*90);
      setTimeout(function(){syncBar();var mp=bar.querySelector('.lm-sticky__mp');mp.classList.remove('is-flash');void mp.offsetWidth;mp.classList.add('is-flash')},n*90+120);
    });
    bar.querySelector('.lm-sticky__btn').addEventListener('click',function(){
      var a=mainAtc();if(!a)return;
      if(a.disabled){var sel=root().querySelector('.lm-inline-bundle-panel:not([hidden])')||a;sel.scrollIntoView({behavior:'smooth',block:'center'});return}
      a.click();
    });
  }
  function txt(el){return el?(el.textContent||'').replace(/\s+/g,' ').trim():''}
  function syncBar(){
    var r=root();if(!r)return;
    var a=mainAtc();if(!a)return;
    if(!bar)buildBar();
    var bundleOpen=!!r.querySelector('.lm-inline-bundle-panel:not([hidden])');
    var flav=r.querySelector('.lm-single-panel .lm-flavor.is-active');
    var img=bundleOpen?r.querySelector('.lm-bundle-slot img'):(flav&&flav.querySelector('img'));
    var imgBox=bar.querySelector('.lm-sticky__img');
    var src=img?img.currentSrc||img.src:'';
    if(imgBox.dataset.src!==src){imgBox.dataset.src=src;imgBox.innerHTML=src?'<img src="'+esc(src)+'" alt="">':''}
    var title,sub,price;
    if(bundleOpen){
      title='YOUR BUNDLE';sub=txt(r.querySelector('[data-lm-bundle-count]'));price=txt(r.querySelector('[data-lm-bundle-total]'));
    }else{
      title=txt(flav&&flav.querySelector('strong,span,p'))||txt(flav)||txt(r.querySelector('h1'));
      var pk=r.querySelector('.lm-single-panel .lm-pack.is-active');var q=r.querySelector('.lm-ritual [data-lm-quantity-input]');
      sub=(pk?(pk.dataset.lmPack==='10'?'10 tins':'24 tins'):'')+(q&&Number(q.value)>1?' × '+q.value:'');
      price=txt(r.querySelector('[data-lm-single-total]'));
    }
    bar.querySelector('.lm-sticky__title').textContent=title||'';
    bar.querySelector('.lm-sticky__sub').textContent=sub||'';
    var priceHtml=esc(price||''),qBox=bar.querySelector('.lm-sticky__qty'),qIn=r.querySelector('.lm-ritual [data-lm-quantity-input]');
    var orig,hint;
    if(bundleOpen){
      orig=r.querySelector('[data-lm-bundle-total-original]');
      var bc=/(\d+)\s*\/\s*(\d+)/.exec(sub||''),bd=r.querySelector('[data-lm-bundle-total-discount]'),left=bc?Number(bc[2])-Number(bc[1]):0;
      hint=left>0?'Pick '+left+' more to complete':(bd&&!bd.hidden&&txt(bd)?'Bundle deal unlocked '+txt(bd):'');
    }else{
      orig=r.querySelector('[data-lm-single-total-original]');hint=txt(r.querySelector('.lm-single-unlock-hint'));
    }
    /* 12 Oct: "X% OFF" outlined pill, same as the buy-box total (desktop: between old and new price, mobile: on the image) */
    var nm=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0},oT=orig&&!orig.hidden?txt(orig):'',pct=oT&&nm(oT)>nm(price)?Math.round((1-nm(price)/nm(oT))*100):0;
    var badge=pct>0&&!(bundleOpen&&/unlocked/i.test(hint||''));
    priceHtml=(hint?'<span class="lm-sticky__hint">'+esc(hint)+'</span>':'')+'<span class="lm-sticky__row">'+(oT?'<s>'+esc(oT)+'</s>':'')+(badge?'<em class="lm-sticky__badge">'+pct+'% OFF</em>':'')+esc(price||'')+'</span>';
    var pEl=bar.querySelector('.lm-sticky__price');if(pEl.dataset.h!==priceHtml){pEl.dataset.h=priceHtml;pEl.innerHTML=priceHtml}
    /* 12 Oct mobile: deal pill + price row (desktop keeps title/sub/price) */
    var oTxt=orig&&!orig.hidden?txt(orig):'',dEl=bar.querySelector('.lm-sticky__deal'),dl='',dn=0,don=false;
    var num=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0};
    if(bundleOpen){if(hint){dl=hint;don=!/^pick/i.test(hint)}}
    else{
      var mm=/add\s+(\d+)\s+more[^%]*?(\d+)\s*%/i.exec(hint||'');
      if(mm){dn=Number(mm[1]);dl='+'+mm[1]+' for '+mm[2]+'% OFF ›'}
      else if(oTxt&&num(oTxt)>num(price)){dl='✓ '+Math.round((1-num(price)/num(oTxt))*100)+'% OFF UNLOCKED';don=true}
    }
    if(dEl.textContent!==dl)dEl.textContent=dl;dEl.hidden=!dl;dEl.classList.toggle('is-on',don);dEl.dataset.n=dn;dEl.tabIndex=dn?0:-1;dEl.setAttribute('aria-disabled',dn?'false':'true');
    var mpH='<b>'+esc(price||'')+'</b>'+(badge?'<em class="lm-sticky__badge">'+pct+'% OFF</em>':(oTxt?'<s>'+esc(oTxt)+'</s>':'')),mpEl=bar.querySelector('.lm-sticky__mp');if(mpEl.dataset.h!==mpH){mpEl.dataset.h=mpH;mpEl.innerHTML=mpH}
    qBox.hidden=bundleOpen||!qIn;if(qIn)qBox.querySelector('span').textContent=qIn.value||'1';
    var label=txt(a)||'ADD TO CART';bar.querySelector('.lm-sticky__btn span').textContent=/bundle/i.test(label)?'ADD BUNDLE':'ADD TO CART';
    var rect=a.getBoundingClientRect();
    var footer=document.getElementById('shopify-section-footer');
    var sm=document.getElementById('shopify-section-mobile-sticky-menu');var smh=(sm&&sm.offsetParent!==null&&getComputedStyle(sm).display!=='none')?sm.getBoundingClientRect().height:0;bar.style.bottom=(smh>0&&smh<120?smh:0)+'px';
    var nearFooter=footer&&footer.getBoundingClientRect().top<window.innerHeight;
    var show=(rect.bottom<0||rect.top>window.innerHeight)&&!nearFooter&&window.scrollY>300;
    if(show!==bar.classList.contains('is-on')){
      bar.classList.toggle('is-on',show);bar.setAttribute('aria-hidden',show?'false':'true');
      bar.querySelector('.lm-sticky__btn').tabIndex=show?0:-1;
      document.documentElement.classList.toggle('lm-sticky-on',show);
    }
  }
  var raf=0;function onScroll(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;syncBar()})}
  window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll);
  setInterval(function(){markGifts();annotateGifts();syncBar()},400);
})();

